/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, Text, TextInput, TouchableOpacity, Image, Dimensions, Keyboard, ScrollView, Platform } from 'react-native'
import { Icon, Item, Input } from 'native-base'
import styles from './Styles/SearchBarComponentStyle'
import { ButtonGroup, ListItem, SearchBar } from "react-native-elements"
import { SvgSearch, SvgBlueBarCoder, SvgWhiteBarcoder } from './SvgComponent'
import TextComponent from './TextComponent';
import { getAvatar } from '../Lib/utils'
import FadeView from './FadeView'
import { Fonts } from '../Themes'

import I18n from "i18n-js"

const unwrapBBCodes = ( string ) => {
  const simplify = (BBCode) => {
    var found = BBCode.match(/\[link ([a-zA-Z]+) (\w{14}|\w{32}) ([-_a-zA-Z]+) (.*)\]/);
    return found? found[4] : false
  }

  var parts = string.split(/(\[[^]*?\])/)
  if( parts.length == 1 ) return string

  for (var i = 0; i < parts.length; ++i) {
    var plainText = simplify(parts[i])
    if(plainText) parts[i] = plainText
  }

  return parts.join(' ')
}
export default class SearchBarComponent extends Component {
  constructor(props) {
    super(props)
    this.select =[0,0]
    this.state = { height : false }
    this.value = props.initialValue? unwrapBBCodes(props.initialValue): ''
    this.activeSearch = [ ]
    var {height, width} = Dimensions.get('window')
    this.maxUpHeight = (height < 800) ? 100 : 170 // was 250 for all phones

    this.keyboardWillShowListener = Keyboard.addListener('keyboardWillShow', this.keyboardWillShow.bind(this))
    this.keyboardWillHideListener = Keyboard.addListener('keyboardWillHide', this.keyboardWillHide.bind(this))
  }

  keyboardWillShow = e => { // remeasure where we are on the screen and pass back to caller which handles the keyboard situation

    console.log("keybd will show sbc")
    let measureOutput = {}
    if (this.topViewRef) { // works
      // this is async
      this.topViewRef.measure((x, y, width, height, pageX, pageY) => {
                 console.log("keyboard will show layout MEASURE" , x, y, width, height, pageX, pageY)
                 measureOutput.x = x
                 measureOutput.y = y
                 measureOutput.width = width
                 measureOutput.height = height
                 measureOutput.pageX = pageX
                 measureOutput.pageY = pageY

                // send info back to parent
                if (this.props.onLayoutAndMeasure) { // layout may not be sent back properly hmm but dont care now, want measure to full screen
                  this.props.onLayoutAndMeasure({}, measureOutput)
                }
      })
    }

  }

  keyboardWillHide = e => {

  }

  componentWillUnmount() {

    this.keyboardWillShowListener.remove( )
    this.keyboardWillHideListener.remove( )
  }

  // nope this does not get called 
  DELETEonLayout = (e) => {
    console.log("inner search bar component layout " + JSON.stringify(e.nativeEvent.layout))
  }

  checkMarginRight = ( ) => (this.props.barcoder? 40: (this.props.isCountdown? 30: 5))
  clearText = ( ) => {
    this.textInput.clear( )
    if(this.props.clearButton) {
      this.props.clearButtonClick( )
    }
  }
  collectTags = ( ) => {
    let text = this.value
    var tags = [ ]
    for( var i = 0 ; i < text.length ; ++ i ) {
      let c = text[i]
      if( c === '@' ) {
        let begin = i
        for( var j = begin; j < text.length ; ++ j ) {
          let end = text[j]
          if( end === ' ' ) {
            tags.push({ begin : begin, end : j-1 })
            break
          }
        }
        if( j === text.length ) tags.push({ begin : begin, end : text.length })
      }
    }
    return tags
  }
  processTags = ( ) => {
    let [ start, end ] = this.select
      , tags = this.collectTags ( )
    var activeTag = false
    for( var i = 0 ; i < tags.length ; ++ i ) {
      let tag = tags[i]
      if( start > tag.begin && end <= (tag.end+1) )
        activeTag = tag
    }
    this.activeTag = activeTag
    this.setState({ render : true })
  }
  onSelect = ({ nativeEvent : { text, selection : { start, end }}}) => {
    if( typeof this.props.atTaggable === 'undefined' )
      return


    // console.log(`selection update: ${start} -> ${end}`)
    this.select = [ start, end ]
    if( end <= this.value.length )
      this.processTags ( )
  }
  onSubmitEditing = ( ) => {
    if( this.props.onSubmitEditing )
      this.props.onSubmitEditing (this.value)
  }
  onChangeText = ( text ) => {
    if( typeof this.props.atTaggable === 'undefined' ) {
      const forceLowerCase = typeof this.props.forceLowerCase != 'undefined' && this.props.forceLowerCase
      this.value = forceLowerCase ? text.toLowerCase() : text
      if( this.props.onChangeText )
        this.props.onChangeText (text)

      return
    }

    this.value = text
    this.processTags ( )
    if( this.props.onChangeText )
      this.props.onChangeText (text)

    if( this.activeTag ) {
      let search = this.value.slice( this.activeTag.begin+1, this.activeTag.end+1 )
      if( search.length > 1 ) {
        this.searchQuery = search
        console.log('ready to call search for ' + search)
        this.props.api.searchUser({ 'limit' : 100, 'user' : search })
        .then(result => {
          if (result && result.data) {
            let names = result.data.data
            if( this.activeTag ) {
              let newSearch = this.value.slice( this.activeTag.begin+1, this.activeTag.end+1 )
              if( newSearch === this.searchQuery )
                this.activeSearch = names
              console.log("in .then from .api just set this.activeSearch to an array of len " + this.activeSearch.length)
              this.setState({ render : true })
            }
          }
          else console.log("no result from search")
        }).catch(console.log)
      }
    }
  }
  insert = ( User ) => {
    let str = this.value
      , before = str.slice(0, this.activeTag.begin)
      , after = str.slice(this.activeTag.end+1)
      , next = `${before}@${User.Username}${after}`
    this.value = next
    if( after.length < 1 ) this.value += ' '
    this.setState({ render : true })
    if( this.props.onChangeText )
      this.props.onChangeText (this.value)
  }
  userRow = ( User ) => {
    return (<View style={{backgroundColor: 'white', width: '100%'}}>
    <TouchableOpacity style={{ flexDirection : 'row', backgroundColor : 'white', height : 50, width : '100%' }} activeOpactiy={0.5} underlayColor={'white'} onPress={this.insert.bind(this,User)}>
      <Image source={{ uri: getAvatar(User.UserId) }} resizeMode='contain' style={{ width : 40, height : 40, borderRadius : 20, margin : 5 }} />
      { (User.FirstName.length > 1 || User.LastName.length > 1)
          ? <View style={{ marginTop: 14, flex : 1, flexDirection : 'column' }}>
              <Text style={{ fontFamily : Fonts.style.font.bold, fontSize : 14, lineHeight : 18, marginLeft : 15, color : 'black' }}>{User.Username}</Text>
              <Text style={{ fontFamily : Fonts.style.font.bold, fontSize : 13, lineHeight : 18, marginLeft : 15, color : '#bababa' }}>{User.FirstName} {User.LastName}</Text>
            </View>
          : <View style={{ marginTop: 14, flex : 1, flexDirection : 'column' }}>
            <Text style={{ fontFamily : Fonts.style.font.bold, fontSize : 14, lineHeight : 18, marginLeft : 15, color : 'black' }}>{User.Username}</Text>
            <Text style={{ fontFamily : Fonts.style.font.bold, fontSize : 13, lineHeight : 18, marginLeft : 15, color : '#bababa' }}></Text>
            </View>
      }
    </TouchableOpacity></View>)
  }
  isIterable = (obj) => {
    // checks for null and undefined
    if (obj == null) {
      return false;
    }
    return typeof obj[Symbol.iterator] === 'function'
  }
  tagResults = ( ) => {
    if( ! this.activeTag ) return (<Text></Text>)
    let search = this.value.slice( this.activeTag.begin+1, this.activeTag.end+1 )
    const beginsWith = (a,b) => a.length > 2 && a.toLowerCase( ).indexOf( b.toLowerCase( ) ) === 0
    const inUsernameFirstLast = User => beginsWith(User.Username,search) || beginsWith(User.FirstName,search) || beginsWith(User.LastName,search)
    let outputObjects = null
    if( search.length < 2 || ! this.activeSearch.length ) { // change to < 2 to use local search only for 1 chr searches
      console.log("loc1")

      let localFollowing = this.isIterable(this.props.following) ? this.props.following : null
      if (!localFollowing) return null
  
      outputObjects =  [/*...this.props.following*/...localFollowing]
                .filter( inUsernameFirstLast )
                .sort( (a,b) => a.Username < b.Username? -1: 1 )
                /*.slice(0,5)*/
                .map(this.userRow)

    } else if( this.activeSearch.length ) {
      console.log("loc2 active search len = " + this.activeSearch.length)
      outputObjects = this.activeSearch/*.slice(0,5)*/.map(this.userRow)
    }
  
    // add some empty rows at top
    // dont do for scroll view trial or the rows scroll out of view
    if (false) {
      let blankRow = (<View style={{height : 50, width : '100%', backgroundColor : 'white'}}/>)
      for (let i = 0; i < 6; i++) outputObjects.unshift(blankRow)
    }
    return outputObjects
  }
  onBlur = ( ) => {
    this.activeTag = false
    this.blurred = true
    if( this.props.onBlur )
      this.props.onBlur ( )
    this.setState({ render : false })
  }
  onFocus = ( ) => {
    this.blurred = false
    if( this.props.onfocus )
      this.props.onfocus( )
  }
  updateSize = ( height ) => {
    if( this.props.autoGrow !== true ) return
    height = 170
    let min = this.props.minHeight || 70
      , max = this.props.maxHeight || this.maxUpHeight
    var nextHeight = height > max? max: height
    nextHeight = nextHeight < min? min: nextHeight

    this.nextHeight = nextHeight
    this.setState({ height : nextHeight })
  }
  render ( ) {
    const { onChangeText, onClearText, fetching, clearButtonClick, value, textWrapperStyle = null, onPost = null
          , autoCorrect = false, spellCheck = false, multiline = false, numberOfLines = 1, autoCapitalize = 'sentences'
          , blurOnSubmit = true, defaultValue = '', barcoder = false
          , onPressBarcoder, isWhiteBarCoder, isCountdown = false, countText
          , placeholder, maxLength, onfocus, onBlur, autoGrow = false, maxHeight = this.maxUpHeight, minHeight = 70
          } = this.props
        , showUsers = this.activeTag ? true : false

    var addedStyle = { }
    if( this.state.height ) addedStyle.height = this.state.height
    
    // workaround to fix spell checking getting erased when we set value= property
    // render first block if we have a value but not initial value OR if we did have an initial value, and the user has already
    // started typing (not NOvalue being passed in which is an undefined prop but left in for reference)
    let textInputAttribs = (this.value && !this.props.initialValue) || this.value !== this.props.initialValue ?
      {
        defaultValue: this.props.initialValue,
        onSelectionChange: this.onSelect,
      } :
      {
      }
    if (onBlur) textInputAttribs.onBlur = this.onBlur
    if (onfocus) textInputAttribs.onFocus = this.onFocus
    if (blurOnSubmit) textInputAttribs.blurOnSubmit = blurOnSubmit
    if (autoCapitalize) textInputAttribs.autoCapitalize = autoCapitalize

/*
{
// workaround to fix spell checking getting erased when we set value= property
// render first block if we have a value but not initial value OR if we did have an initial value, and the user has already
// started typing (not NOvalue being passed in which is an undefined prop but left in for reference)
((this.value && !this.props.initialValue) || this.value !== this.props.initialValue)
?
<TextInput
  ref={ref => { this.textInput = ref }}
  keyboardType='default'
  value={this.value} onBlur={this.onBlur} onFocus={this.onFocus}
  maxLength={maxLength} blurOnSubmit={blurOnSubmit} autoCorrect={autoCorrect} spellCheck={spellCheck}
  numberOfLines={numberOfLines} multiline={multiline}
  autoCapitalize='sentences' onChangeText={this.onChangeText}
  placeholder={placeholder} onSelectionChange={this.onSelect}
  defaultValue={this.props.initialValue}
  style={[styles.searchInput, { marginRight : this.checkMarginRight ( ) }, this.props.textInputStyle, addedStyle ]}
  placeholderTextColor='#d6d2d9'
  onContentSizeChange={ e => this.updateSize(e.nativeEvent.contentSize.height) } />
:
<TextInput
  ref={ref => { this.textInput = ref }}
  keyboardType='default'
  value={this.value} onBlur={this.onBlur} onFocus={this.onFocus}
  maxLength={maxLength} blurOnSubmit={blurOnSubmit} autoCorrect={autoCorrect} spellCheck={spellCheck}
  numberOfLines={numberOfLines} multiline={multiline}
  autoCapitalize='sentences' onChangeText={this.onChangeText} onSubmitEditing={this.onSubmitEditing}
  placeholder={placeholder} onSelectionChange={this.onSelect}
  style={[styles.searchInput, { marginRight : this.checkMarginRight ( ) }, this.props.textInputStyle, addedStyle ]}
  placeholderTextColor='#d6d2d9'
  onContentSizeChange={ e => this.updateSize(e.nativeEvent.contentSize.height) } />
}
*/      
    let postText = this.props.isBusy ? '...' : I18n.t('postDetail.post') // Sending... is too long when comment is longer (interferes)
    //console.log('ready to render TextInput with this.props.shouldClearTyping = ' + this.props.shouldClearTyping)
    let tagRes = this.tagResults( )

    if (this.props.shouldClearTyping) this.value = '' // trial Aug 5 2021 to keep last typed comment from returning

    //console.log("rendering TextInput value = " + (this.props.shouldClearTyping ? '' : this.value) + " placeholder = " + placeholder)
  
    // ref:  https://stackoverflow.com/questions/42740060/reactnative-ref-and-onlayout-on-custom-component
    // onLayout is a method of View and doesn't get inherited by every Component. Passing in a prop and setting it on a containing View would solve the problem.

    console.log("@ scroll height = " + this.maxUpHeight - 5)

    const isWeb = Platform.OS == 'web'
    let webStyle = isWeb ? {outline: 'none'} : {}

    // for debug Text Input 
    let styleArray = [styles.searchInput, { marginRight : this.checkMarginRight ( ) }, webStyle, this.props.textInputStyle, addedStyle /*, {padding: 0, marginBottom: -30}*/ ]

    //console.log("styleArray TextInput = " + JSON.stringify(styleArray))
    
    let narrowStyle = {}
    if (typeof window.mainViewWidthFraction != 'undefined' && window.mainViewWidthFraction < 1) {


      theWidth = '100%'

      if (this.props.standaloneScreen)
         theWidth = ((100 - window.mainViewWidthFraction*100) * 0.94).toFixed(1).toString() + '%'
      else // in the normal screen nav stack
         theWidth = ((window.mainViewWidthFraction*100) * 0.94).toFixed(1).toString() + '%'


      narrowStyle = {width: theWidth}

      //console.log("search bar component theWidth = " + theWidth)
      
    }
    return (
      <View ref={(r)=>this.topViewRef = r} onLayout={(layout) => {
          
          let measureOutput = {}
          if (this.topViewRef) { // works
            // this is async
            this.topViewRef.measure((x, y, width, height, pageX, pageY) => {
                       //console.info("top view search bar component layout MEASURE" , x, y, width, height, pageX, pageY)
                       measureOutput.x = x
                       measureOutput.y = y
                       measureOutput.width = width
                       measureOutput.height = height
                       measureOutput.pageX = pageX
                       measureOutput.pageY = pageY

                      // send info back to parent
                      if (this.props.onLayoutAndMeasure) { // layout may not be sent back properly hmm but dont care now, want measure to full screen
                        this.props.onLayoutAndMeasure(layout, measureOutput)
                      }
            })
          }
         
      }
      } style={[styles.searchContainer, this.props.style, addedStyle, narrowStyle]}>
         
          <View style={{backgroundColor: 'red', /* this view just to provide a line because top border floats on scrollview (?) */
            height: 2, 
            position: 'absolute', 
            zIndex: 50,
            display : (showUsers ? 'flex' : 'none'), 
            width:'110%', 
            top : -this.maxUpHeight-2, 
            left : this.props.atTagPopupLeft ? this.props.atTagPopupLeft : 0 }}>
          </View>
          <ScrollView contentContainerStyle={{ alignItems : 'center', justifyContent : 'flex-end' }} 
                      style={{ flexDirection : 'column', width : '110%', position : 'absolute', zIndex : 50
                      , display : (showUsers ? 'flex' : 'none') 
                      , top : -this.maxUpHeight, left : this.props.atTagPopupLeft ? this.props.atTagPopupLeft : 0, height : this.maxUpHeight - 5
                      , borderColor:'red',topBottomWidth:1, backgroundColor: 'white'}}>
            { /*this.tagResults ( )*/ tagRes}
          </ScrollView>       

          <TextInput
            {...textInputAttribs}
            ref={ref => { this.textInput = ref }}
            keyboardType='default'
            value={this.props.shouldClearTyping ? '' : this.value}
            maxLength={maxLength} autoCorrect={autoCorrect} spellCheck={spellCheck}
            numberOfLines={numberOfLines} multiline={multiline}
            onChangeText={this.onChangeText} onSubmitEditing={this.onSubmitEditing}
            placeholder={placeholder} onSelectionChange={this.onSelect}
            // last {} for removing bottom blank line but acts weird for backspacing so leave it out
            style={[styles.searchInput, { marginRight : this.checkMarginRight ( ) }, webStyle, this.props.textInputStyle, addedStyle /*, {padding: 0, marginBottom: -30}*/ ]}
            placeholderTextColor='#d6d2d9'
            onContentSizeChange={ e => this.updateSize(e.nativeEvent.contentSize.height) } />

          {onPost && 
            <View style={styles.postButton}>
              <TouchableOpacity onPress={onPost} hitSlop={{left: 25, right: 25, top: 25, bottom: 25}}>
                <Text style={{fontWeight: 'bold'}}>{postText}</Text>
              </TouchableOpacity>
            </View>
          }

          { ! this.props.hiddenClear &&

            <View style={[styles.clearButton, { right: barcoder ? 50 : 12 }]}>
              <TouchableOpacity onPress={() => this.clearText()} hitSlop={{left: 15, right: 15, top: 15, bottom: 15}}>
                <SvgSearch size={20} />
              </TouchableOpacity>
            </View>

          }

          { barcoder &&
            <View style={styles.barcoder}>
              <TouchableOpacity onPress={onPressBarcoder}>
                {isWhiteBarCoder ? <SvgWhiteBarcoder size={30} /> : <SvgBlueBarCoder size={30} />}
              </TouchableOpacity>
            </View>
          }

          { isCountdown &&
            <View style={styles.barcoder}>
              <View style = {styles.countView}>
                <TextComponent allowFontScaling={false} style = {styles.textCount} text={countText} />
                  <View style = {styles.middleCount}></View>
                <TextComponent allowFontScaling={false} style = {styles.textCount} text={`55`} />
              </View>
            </View>
          }
      </View>
    )
  }
}
